import React from 'react';
import { useNavigate } from 'react-router-dom';
import useTrialBanner from './useTrialBanner';
import useTrialDemoCompact from '../demo-data/useTrialDemoCompact';
import styles from './TrialBanner.module.css';

/**
 * Banner informativo exibido quando a empresa está em trial interno ativo.
 * Mostra dias restantes e botão para assinar.
 * Não é exibido se a empresa já tiver assinatura Stripe ativa.
 * No celular, com dados de exemplo, a faixa dos exemplos mostra os dois avisos
 * numa linha só (TrialDemoCompactBanner) e esta some.
 */
const TrialBanner = () => {
  const navigate = useNavigate();
  const { visible, message, shortMessage, urgency } = useTrialBanner();
  const { compact } = useTrialDemoCompact();

  if (!visible || compact) return null;

  return (
    <div className={`${styles.banner} ${styles[urgency]}`}>
      <span className={`${styles.message} ${styles.full}`}>{message}</span>
      <span className={`${styles.message} ${styles.short}`}>{shortMessage}</span>
      <button
        className={styles.ctaButton}
        onClick={() => navigate('/subscription/plans')}
      >
        <span className={styles.full}>Assinar agora</span>
        <span className={styles.short}>Assinar</span>
      </button>
    </div>
  );
};

export default TrialBanner;
